module.exports = __webpack_public_path__ + "static/media/volume-up.eb0896dd.svg";